var _circle, _path, _path2, _rect, _path3, _path4, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearSeatBelts50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12,17v8H7.03C7.01,24.67,7,24.34,7,24c0-2.49,0.54-4.87,1.52-7H12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41,24v1h-5v-8h3.48C40.46,19.13,41,21.51,41,24z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 29,
    y: 19,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35,15h-8c-1.105,0-2,0.895-2,2v8c0,1.105,0.895,2,2,2h8c1.105,0,2-0.895,2-2v-8 C37,15.895,36.105,15,35,15z M35,25h-8v-8h8V25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18,17l-2-2h-5v12h5l2-2h5v-8H18z M15,25h-2v-8h2V25z M21,23h-3v-4h3V23z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "14,33 20,33 20,35 23,32 20,29 20,31 14,31"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "34,33 28,33 28,35 25,32 28,29 28,31 34,31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearSeatBelts50);
export default __webpack_public_path__ + "static/media/icons8-wear-seat-belts-50.ec408e81d8e049606560e6e476b9d2e0.svg";
export { ForwardRef as ReactComponent };